import { Box, Text} from '@chakra-ui/react';
import { NavLink } from 'react-router-dom';
function NotFound() {
  return (
    <Box 
    px='2rem' 
    w='100%' 
    minH='90vh' 
    bg='#fcfcfc'

    fontWeight='900'
    style={{ fontFamily: 'Mulish, sans-serif' }}
    d='flex'
    flexDir='column'
    justifyContent='center'
    alignItems='center'
    >
        <Text
          pt='2rem'
          fontSize={['25px', '30px', '35px', '45px']}
        >
          404 Not Found
        </Text>
        <Text 
        px='2rem'
        fontSize={['20px', '20px', '25px', '30px']}
        >
            <NavLink to='/'>
              Click to Home
            </NavLink>
          </Text>
    </Box>
  );
}
export default NotFound;
